import {
  voiceBeatResultSchema,
  voiceSessionGrantSchema,
  voiceToolResultSchema,
  type VoiceEnd,
  type VoiceHeartbeat,
  type VoiceSessionGrant,
  type VoiceSessionRequest,
  type VoiceToolCall,
  type VoiceToolResult,
} from '@secretario/shared';
import { apiFetch } from './http.js';

/** Nova conversa ao vivo, troca para o modo que pensa com calma ou renovação da chave. */
export async function startVoiceSession(
  request: Partial<VoiceSessionRequest>,
): Promise<VoiceSessionGrant> {
  return voiceSessionGrantSchema.parse(
    await apiFetch<unknown>('/v1/voice/sessions', { method: 'POST', body: request }),
  );
}

export async function runVoiceTool(
  sessionId: string,
  call: VoiceToolCall,
): Promise<VoiceToolResult> {
  return voiceToolResultSchema.parse(
    await apiFetch<unknown>(`/v1/voice/sessions/${sessionId}/tools`, {
      method: 'POST',
      body: call,
    }),
  );
}

export async function voiceHeartbeat(sessionId: string, beat: VoiceHeartbeat): Promise<number> {
  const result = voiceBeatResultSchema.parse(
    await apiFetch<unknown>(`/v1/voice/sessions/${sessionId}/heartbeat`, {
      method: 'POST',
      body: beat,
    }),
  );
  return result.secondsLeft;
}

/** Cochilo: a conversa fica aberta no servidor, sem contar minutos. */
export function pauseVoiceSession(sessionId: string, beat: VoiceHeartbeat): Promise<void> {
  return apiFetch<void>(`/v1/voice/sessions/${sessionId}/pause`, { method: 'POST', body: beat });
}

export function endVoiceSession(sessionId: string, end: VoiceEnd): Promise<void> {
  return apiFetch<void>(`/v1/voice/sessions/${sessionId}/end`, { method: 'POST', body: end });
}
